/**
 * @desc 财务画像-财务舞弊分析
 * @author caoyx
 */
import React, { PureComponent } from 'react';
import { Spin } from 'antd';
import NoData from '../../common/noData/NoData';
import GroupBox from '../../common/groupBox/GroupBox';
import ExtraInfoTitle from '../../common/extraInfoTitle/ExtraInfoTitle';
import {commonRequest, changeAnchor} from '../common/commons';
import ScorePane from '../common/scorePane/ScorePane';
import AbnormalSummary from './subComponents/AbnormalSummary';
import FraudFinance from './subComponents/FraudFinance';
import FraudSurfaceTip from './subComponents/FraudSurfaceTip';
import PathAnalysis from './subComponents/PathAnalysis';
import FraudTemplate from './subComponents/FraudTemplate';
import { queryFraudAnalysis } from '../../../services/financialPicture/fraudAnalysis';

export default class FinancialFraudAnalysis extends PureComponent {
    constructor(props) {
        super(props);
        this.nav = [
            { name: '财务舞弊评分', id: 'fraud-score' },
            { name: '财务舞弊动机', id: 'fraud-motive' },
            { name: '财务舞弊表象提示', id: 'fraund-surface-tip' },
            { name: '财务舞弊异常指标分析', id: 'abnormal-summary' },
            { name: '财务舞弊路径', id: 'path-analysis' }
        ];
        this.state = {
            loading: false,
            baseData: {},
            summaryData: {},
            analysisData: [],
            pathData: [],
            keyValueData: []
        };
    }

    componentDidMount() {
        changeAnchor(this.nav);
        this.getData();
    }

    getData = () => {
        this.setState({
            loading: true
        });

        queryFraudAnalysis(commonRequest()).then((data) => {
            data = data || {};
            let { finacialPortraitBasicFraudVO, finacialPortraitFraudStaticsVO, finacialFraudKeyValueVO, finacialPortraitFraudPathVO, analysisList } = data;

            this.setState({
                baseData: finacialPortraitBasicFraudVO || {},
                summaryData: finacialPortraitFraudStaticsVO || {},
                analysisData: analysisList || [],
                pathData: finacialPortraitFraudPathVO || [],
                keyValueData: finacialFraudKeyValueVO || [],
                loading: false
            });
        }).catch(() => {
            this.setState({
                loading: false
            });
        });
    };

    render() {
        const { baseData, summaryData, analysisData, pathData, keyValueData, loading } = this.state;
        const { explain, industry, fraudTotalScore, fraudScoreTypeList } = baseData;

        return (
            <div>
                {/* 财务舞弊分析结果 */}
                <GroupBox id="fraud-score" title="财务舞弊评分" explain={explain} industry={industry}>
                    <ScorePane loading={loading} score={fraudTotalScore} radarData={fraudScoreTypeList}/>
                </GroupBox>

                {/* 财务舞弊动机 */}
                <div id="fraud-motive">
                    <FraudFinance
                        data={baseData}
                        loading={loading}
                    />
                </div>
                {/* 财务舞弊表象提示 */}
                <div id="fraund-surface-tip">
                    <FraudSurfaceTip />
                </div>
                {/* 舞弊异常点汇总 */}
                <div id="abnormal-summary">
                    <AbnormalSummary
                        data={summaryData}
                        analysisData={analysisData}
                        loading={loading}
                    />
                </div>

                {/* 舞弊 */}
                <div>
                    {keyValueData && keyValueData.map(item => (
                        <div key={item.id} id={item.id}>
                            <div className="sub-title">
                                {item.fraudName}
                                <ExtraInfoTitle riskScore={item.score} explain={item.explain} />
                            </div>
                            {
                                item.list && item.list.map(subItem => (
                                    <FraudTemplate key={subItem.abnormalIndex + subItem.featureType} data={subItem} />
                                ))
                            }
                        </div>
                    ))}
                </div>

                {/* 财务舞弊路径 */}
                <GroupBox id="path-analysis" title="财务舞弊路径">
                    {
                        loading ?
                            <Spin /> :
                            pathData.length ?
                                pathData.map((item) => (
                                    <PathAnalysis key={item.fraudPathIndex} data={item} />
                                )) :
                                <NoData />
                    }
                </GroupBox>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/financialPicture/financialFraudAnalysis/FinancialFraudAnalysis.jsx